import { CartLinesUpdateEvent } from '@shopify/events';

class ProductBundleOffer extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[data-bundle-submit]');
    this.variantInput = this.querySelector('[data-bundle-variant]');
    this.form?.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.#onSubmit);
  }

  #currentVariantId() {
    const pageVariant = this.closest('.buy-buttons-block')?.querySelector(
      'product-form-component input[name="id"][ref="variantId"]'
    );
    return pageVariant?.value || this.variantInput?.value;
  }

  #onSubmit = async (event) => {
    event.preventDefault();
    if (!this.button || this.button.disabled) return;

    const variantId = Number(this.#currentVariantId());
    if (!variantId) return;

    const items = [1, 2, 3].map((slot) => ({
      id: variantId,
      quantity: 1,
      properties: { _bundle_item: String(slot) },
    }));

    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });

    this.button.disabled = true;
    const originalLabel = this.button.textContent;
    this.button.textContent = 'Adding…';

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((item) => ({
          merchandiseId: String(item.id),
          quantity: item.quantity,
        })),
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items,
          sections: sectionIds.join(','),
        }),
      }).then((res) => res.json());

      if (response.status) {
        throw new Error(response.description || response.message || 'Could not add offer');
      }

      const cart = await fetch('/cart.js').then((res) => res.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'product-bundle-offer',
          itemCount: 3,
          productId: this.dataset.productId,
          sections: response.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      console.error(error);
    } finally {
      this.button.disabled = false;
      this.button.textContent = originalLabel;
    }
  };
}

if (!customElements.get('product-bundle-offer')) {
  customElements.define('product-bundle-offer', ProductBundleOffer);
}
